// AbMapPreviewTable — Ergebnistabelle von POST /rulesets/preview (nicht persistiert). Zeigt alle
// 9 Regelset-Felder je erkannte Zeile + POS (source_pos oder laufender Index). Kein SAP-Abgleich
// hier (Bauplan-Vorgabe: "compare hier optional weglassen wenn zu teuer" — es gibt zudem keinen
// api.js-Endpunkt fuer einen Abgleich ungespeicherter Vorschau-Zeilen gegen offene Bestellungen).

import React from 'react';
import { Chip, money, qty, fmtDate } from '../components/ui';
import { FIELDS } from './rulesetModel';

const AbMapPreviewTable = ({ isDarkMode, t, preview, supplierId }) => {
  const textMuted = isDarkMode ? 'text-white/55' : 'text-slate-500';
  if (!preview) {
    return <p className={`text-sm py-4 text-center ${textMuted}`}>{t('ab.map.previewEmptyHint')}</p>;
  }
  const lines = Array.isArray(preview.lines) ? preview.lines : [];
  // POST /rulesets/preview liefert KEIN supplierId (nur matched/lineCount/lines) — der Lieferant-
  // Bezug fuer die Ueberschrift kommt daher vom Formular des Aufrufers, nicht aus der Antwort.
  const supplierLabel = preview.matched ? (supplierId || t('ab.field.supplier')) : t('ab.map.previewMatchedNo');

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 flex-wrap">
        <Chip tone={preview.matched ? 'green' : 'slate'} isDarkMode={isDarkMode}>{preview.matched ? t('common.yes') : t('common.no')}</Chip>
        <span className={`text-sm font-medium ${isDarkMode ? 'text-white/80' : 'text-slate-700'}`}>
          {t('ab.map.previewResultTitle', { lineCount: preview.lineCount ?? lines.length, supplier: supplierLabel })}
        </span>
      </div>
      {lines.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-xs">
            <thead>
              <tr className={isDarkMode ? 'border-b border-white/10' : 'border-b border-slate-200'}>
                <th className={`text-left px-2 py-1.5 uppercase tracking-wide font-semibold ${textMuted}`}>{t('ab.map.previewPosHeader')}</th>
                {FIELDS.map((f) => (
                  <th key={f} className={`text-left px-2 py-1.5 uppercase tracking-wide font-semibold ${textMuted}`}>{t(`ab.field.${f.toLowerCase()}`)}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lines.map((l, i) => (
                <tr key={i} className={isDarkMode ? 'border-b border-white/5' : 'border-b border-slate-100'}>
                  <td className="px-2 py-1.5 font-mono">{l.source_pos ?? i + 1}</td>
                  <td className="px-2 py-1.5 font-mono">{l.ebeln || '—'}</td>
                  <td className="px-2 py-1.5 font-mono">{l.ebelp || '—'}</td>
                  <td className="px-2 py-1.5 font-mono">{l.labnr || '—'}</td>
                  <td className="px-2 py-1.5">{l.matnr || '—'}</td>
                  <td className="px-2 py-1.5">{l.mfrpn || '—'}</td>
                  <td className="px-2 py-1.5 tabular-nums">{qty(l.menge)}</td>
                  <td className="px-2 py-1.5 tabular-nums">{money(l.netpr, l.waers)}</td>
                  <td className="px-2 py-1.5">{fmtDate(l.eeind)}</td>
                  <td className="px-2 py-1.5">{l.waers || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AbMapPreviewTable;
